import { render } from "./BackupSchedule.vue?vue&type=template&id=2cd163f9&scoped=true"
import script from "./BackupSchedule.vue?vue&type=script&lang=js"
export * from "./BackupSchedule.vue?vue&type=script&lang=js"

import "./BackupSchedule.vue?vue&type=style&index=0&id=2cd163f9&scoped=true&lang=less"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd163f9"]])

export default __exports__